"use strict";
// @ts-ignore
try {
    self['workbox:broadcast-update:7.4.0'] && _();
}
catch (e) { }
